import { render, staticRenderFns } from "./DialogRoom.vue?vue&type=template&id=10f134cb"
import script from "./DialogRoom.vue?vue&type=script&lang=js"
export * from "./DialogRoom.vue?vue&type=script&lang=js"
import style0 from "./DialogRoom.vue?vue&type=style&index=0&id=10f134cb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports